var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPricingPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_1328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64.98C49.6731 64.98 64 50.6531 64 32.98C64 15.3069 49.6731 0.97998 32 0.97998C14.3269 0.97998 0 15.3069 0 32.98C0 50.6531 14.3269 64.98 32 64.98Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8829 46.4163C25.3124 46.5433 24.7642 46.4772 24.2708 46.3353C23.7919 46.1976 23.3752 45.9872 23.0746 45.8064C22.9261 45.7172 22.8109 45.6382 22.736 45.5841C22.6987 45.5572 22.6718 45.5367 22.6562 45.5246C22.6484 45.5186 22.6435 45.5146 22.6415 45.5131C22.6405 45.5123 22.641 45.5127 22.6415 45.5131L22.6433 45.5145C22.6437 45.5148 22.6447 45.5157 21.9342 46.3755C21.2238 47.2354 21.2242 47.2357 21.2246 47.236L21.2255 47.2368L21.2275 47.2384L21.2325 47.2425C21.2362 47.2455 21.2408 47.2493 21.2462 47.2536C21.257 47.2623 21.2712 47.2734 21.2885 47.2869C21.3231 47.3137 21.3705 47.3497 21.43 47.3926C21.5486 47.4782 21.7162 47.5927 21.9253 47.7184C22.3399 47.9676 22.9373 48.273 23.6543 48.4792C24.779 48.8026 26.2178 48.8783 27.6446 48.1242C28.4337 48.6038 29.3834 48.9121 30.4757 48.9713C32.1662 49.063 34.1313 48.5569 36.3367 47.2926L35.2272 45.3573C33.2834 46.4717 31.7446 46.8061 30.5965 46.7438C30.2011 46.7224 29.8443 46.6538 29.5242 46.5486C30.7877 44.9658 31.0467 43.0231 30.6316 41.5861C30.4007 40.787 29.8952 39.9474 29.0115 39.5883C28.0377 39.1925 27.0469 39.545 26.2644 40.2628C26.2643 40.2629 26.2645 40.2627 26.2644 40.2628C25.2975 41.1494 24.9193 42.4338 24.9797 43.6605C25.026 44.6018 25.3293 45.5681 25.8829 46.4163ZM27.7498 45.1951C28.5839 44.176 28.7084 42.9665 28.4885 42.2053C28.3668 41.7843 28.1983 41.6701 28.1743 41.6563C28.1697 41.6567 28.161 41.658 28.1476 41.6616C28.0968 41.6753 27.9678 41.7273 27.7721 41.9068C27.4038 42.2445 27.1719 42.8223 27.2077 43.5509C27.2348 44.1024 27.4163 44.6834 27.7498 45.1951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2952 25.249L30.6428 20.141L31.6861 18.1694L42.7454 24.0218L39.3926 45.4308L22.6279 31.7004L26.9747 19.9671L29.0665 20.7421L25.2726 30.983L37.7916 41.2361L40.2952 25.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5794 28.0869L28.5508 20.1529L30.6349 19.3574L33.6635 27.2914L31.5794 28.0869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1609 30.9404C32.7642 30.9393 32.3772 30.8179 32.051 30.5922C31.7248 30.3665 31.4748 30.0471 31.3339 29.6763C31.1875 29.2871 31.1693 28.8613 31.2818 28.461C31.3944 28.0608 31.6319 27.7069 31.9597 27.4511C32.2875 27.1952 32.6885 27.0508 33.1041 27.0389C33.5198 27.027 33.9284 27.1481 34.2703 27.3847C34.6122 27.6213 34.8697 27.961 35.005 28.3541C35.1404 28.7473 35.1466 29.1734 35.0227 29.5704C34.8989 29.9673 34.6515 30.3143 34.3165 30.5608C33.9816 30.8072 33.5767 30.9402 33.1609 30.9404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6927 18.4855L24.9458 22.2056L24.1504 20.1215L33.8973 16.4014L34.6927 18.4855Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_1328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.97998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPricingPortal);
export default __webpack_public_path__ + "static/media/ic_pricing_portal.0d2f15074349e9eb3b1cd86a8ca2b75c.svg";
export { ForwardRef as ReactComponent };